/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InitialScreenAfterLoginEnum } from './InitialScreenAfterLoginEnum';
import {
    InitialScreenAfterLoginEnumFromJSON,
    InitialScreenAfterLoginEnumFromJSONTyped,
    InitialScreenAfterLoginEnumToJSON,
    InitialScreenAfterLoginEnumToJSONTyped,
} from './InitialScreenAfterLoginEnum';

/**
 * Schema-only serializer that describes the user membership settings.
 * Used solely to annotate `MembershipSettingsJSONField` for OpenAPI.
 * @export
 * @interface UserMembershipSettings
 */
export interface UserMembershipSettings {
    /**
     * 
     * @type {boolean}
     * @memberof UserMembershipSettings
     */
    emissionTableDefaultFilterAssignedToSelf: boolean;
    /**
     * 
     * @type {InitialScreenAfterLoginEnum}
     * @memberof UserMembershipSettings
     */
    initialScreenAfterLogin: InitialScreenAfterLoginEnum;
}



/**
 * Check if a given object implements the UserMembershipSettings interface.
 */
export function instanceOfUserMembershipSettings(value: object): value is UserMembershipSettings {
    if ((!('emissionTableDefaultFilterAssignedToSelf' in (value as Record<string, any>)) && !('emission_table_default_filter_assigned_to_self' in (value as Record<string, any>))) || ((value as Record<string, any>)['emissionTableDefaultFilterAssignedToSelf'] === undefined && (value as Record<string, any>)['emission_table_default_filter_assigned_to_self'] === undefined)) return false;
    if ((!('initialScreenAfterLogin' in (value as Record<string, any>)) && !('initial_screen_after_login' in (value as Record<string, any>))) || ((value as Record<string, any>)['initialScreenAfterLogin'] === undefined && (value as Record<string, any>)['initial_screen_after_login'] === undefined)) return false;
    return true;
}

export function UserMembershipSettingsFromJSON(json: any): UserMembershipSettings {
    return UserMembershipSettingsFromJSONTyped(json, false);
}

export function UserMembershipSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMembershipSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'emissionTableDefaultFilterAssignedToSelf': json['emission_table_default_filter_assigned_to_self'],
        'initialScreenAfterLogin': InitialScreenAfterLoginEnumFromJSON(json['initial_screen_after_login']),
    };
}

export function UserMembershipSettingsToJSON(json: any): UserMembershipSettings {
    return UserMembershipSettingsToJSONTyped(json, false);
}

export function UserMembershipSettingsToJSONTyped(value?: UserMembershipSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emission_table_default_filter_assigned_to_self': value['emissionTableDefaultFilterAssignedToSelf'],
        'initial_screen_after_login': InitialScreenAfterLoginEnumToJSON(value['initialScreenAfterLogin']),
    };
}

